// extracted by mini-css-extract-plugin
module.exports = {"typeBtn":"typeBtn--1mojE","active":"active--21m78","ticketRule":"ticketRule--3D7Lu","hide":"hide--1LSau","col":"col--1yJfp","content":"content--1LSin","title":"title--27rjI"};